module.exports = __webpack_public_path__ + "img/hr@2x.4559842c.png";